<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :model="formData" labelAlign="left">
                    <a-divider dashed orientation="left">Form Jabatan</a-divider>

                    <a-form-model-item label="Cabang">
                        <a-select v-model="formData.branch_id">
                            <a-select-option
                                v-for="d in branches"
                                :key="d.hash"
                                :value="d.hash"
                            >
                                {{ d.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Jabatan">
                        <a-input v-model="formData.name"/>
                    </a-form-model-item>

                    <a-form-model-item label="Kode Jabatan">
                        <a-input v-model="formData.position_code"/>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        hash: {
            type: String,
            default: ''
        },
        bank: {
            type: String,
            default: ''
        },
        division: {
            type: String,
            required: true
        },
        position: {
            type: String,
            default: ''
        },
        position_code: {
            type: String,
            default: ''
        },
        branch: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 10 },
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            branches: [],
            formData: {
                division_id: this.division,
                name: this.position,
                position_code: this.position_code,
                branch_id: this.branch
            }
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }
        this.getBranches()
    },
    computed: {
        editing() {
            return this.hash !== "";
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(this.routeUri("api.bank-position.show", {bank: this.hash}))
                .then(response => this.formData = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        getBranches() {
            let params = {
                no_paging: true,
                bank: this.bank
            }

            this.$http
                .get(this.routeUri("api.branches") + '?' + this.$qs.stringify(params))
                .then(response => this.branches = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.processing = true;

            let promise;

            if(!this.editing){
                promise = this.$http.post(
                    this.routeUri("api.bank-position.store"),
                    this.formData
                );
            }else{
                promise = this.$http.put(
                    this.routeUri("api.bank-position.update", {position: this.hash}),
                    this.formData
                );
            }

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.$emit("handleClose", true);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    }
}
</script>